import { Injectable } from '@angular/core';
import { BaseApiService } from '@/app/shared/services/api/base-api.service'
import { Media } from '@/app/shared/models/media/media.model'

@Injectable({
  providedIn: 'root'
})
export class MediaApiService extends BaseApiService<Media> {
  protected readonly endpoint = 'api/media';
}
